import type { DashboardApplication } from "@cv-screener/shared";

export function assignedShortlistRanks(applications: DashboardApplication[], jobId: string, currentApplicationId: string): number[] {
  return [...new Set(applications
    .filter((application) => application.jobId === jobId && application.applicationId !== currentApplicationId && application.status === "Shortlisted" && application.shortlistRank !== null)
    .map((application) => application.shortlistRank as number))]
    .sort((left, right) => left - right);
}
